<!-- Copyright (c) 2022 VMware, Inc. All rights reserved. VMware Confidential -->
<clr-date-container>
    <input type="date"
           clrDate
           id="date"
           #input
           [clrDate]="date"
           (clrDateChange)="onDateChange($event)">
</clr-date-container>
